import { defineStore } from "pinia";
import { v4 as uuidv4 } from "uuid";
const useSliceStore = defineStore("sliceStore", {
  state: () => ({}),
  actions: {
    buildSliceDataFromSliceConfig(component, slot) {
      const sliceConfiguration = this.getSlice(component);
      if (!sliceConfiguration)
        throw new Error(`Slice configuration not found for component: ${component}`);
      return {
        id: uuidv4(),
        type: "slice",
        component,
        enabled: 1,
        xp_status: "approved",
        hydration_mode: sliceConfiguration.hydrationMode ?? "load",
        // TODO: This should be different if it's added via a slot
        slot: slot || "default",
        label: sliceConfiguration.name.label,
        fields: [],
        elements: [],
        properties: {
          dom_id: "",
          settings: []
        },
        administration: {
          gui: {
            open: false,
            el: null,
            hydrationOptions: sliceConfiguration.hydrationOptions
          },
          permissions: []
        }
      };
    }
  },
  getters: {
    getSlice: (state) => (sliceName) => {
      const slice = state.slices[sliceName];
      if (slice)
        return slice;
      return null;
    },
    getSliceComponentNameFromLabelAndGroup: (state) => (sliceName) => {
      if (!sliceName.label || sliceName.label === "")
        return null;
      for (const sliceKey in state.slices) {
        const slice = state.slices[sliceKey];
        if (slice.name.label === sliceName.label && slice.name.group === sliceName.group)
          return sliceKey;
      }
      return null;
    }
  }
});
if (import.meta.hot) {
  import.meta.hot.on("voix-slice-update", (data) => {
    const key = Object.keys(data)[0];
    if (key) {
      const sliceStore = useSliceStore();
      sliceStore.slices[key] = data[key];
      console.info(`Slice updated: ${sliceStore.slices[key].name.label}`, sliceStore.slices[key].fields);
    }
  });
}
export { useSliceStore };
